import { Component, ViewChild, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../../service/events/dashboard.service';
import {BaseForm} from '../../../../base-form';
import {VentasApiService} from '../../../../../service/api/ventas-api.service';
import {FincasApiService} from '../../../../../service/api/fincas-api.service';
import {FormCommonApiService} from '../../../../../service/api/formcommon-api.service';
import {build, pool} from '../../../../../common/classes/request-builder';
import {StorageManager} from '../../../../../common/storage-manager.class';
import { environment } from '../../../../../../environments/environment';
import { RequestButtonComponent } from '../../../../../common/components/request-button/request-button.component';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { Filtering } from '../../../../../service/filtering/filtering';
import { SiexApiService } from '../../../../../service/api/siex-api.service';

import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { VentaModel } from 'src/app/models/ventas/venta.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { VentasFormDefinition } from './form-definition';
import { ReactiveFormChangedField, ReactiveFormValue } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-nueva-carga',
    standalone: false,
    templateUrl: './ventas-form.component.html',
    styleUrls: ['./ventas-form.component.scss']
})
export class VentasFormComponent extends BaseForm<VentaModel> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
            requestButton = new RequestButtonComponent<VentaModel>();
        
    public form!: VentasFormDefinition;
    
    public formRequest = new ReactiveFormRequestCoordinator<VentaModel>;
    
    public override model: VentaModel = {};

    constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public clientesApi: ClientesApiService,
        public ventasApi: VentasApiService,
        public fincasApi: FincasApiService,
        public formApi: FormCommonApiService,
        public siexApi: SiexApiService,
        public override router: Router
    ) {
        super(
            route,
            router,
            dashboard,
            ventasApi.ventasPUT,
            ventasApi.ventasPOST,
            'ventas',
            'Actualizar ' + environment.features.ventaName,
            'Crear ' + environment.features.ventaName
        );

        this.form = new VentasFormDefinition(
            this.getType(),
            this.getModel() as Record<string, string>,
            null
        );
    }

    ngOnInit() {
        this.initFormData();
        this.formRequest.executePhase(FormPhase.LOAD);
        this.softInit(this.getType());
    }

    public formChanges(formModel: ReactiveFormValue<VentaModel>, lastChangedFieldName: ReactiveFormChangedField<VentaModel>): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;
    }


    private initFormData() {
        if (this.form.env.appName !== 'agroleza') {
            this.fincasApi.fincasGET.toPromise().then( (resp_fincas: FincasModel[]) => {
            
                if (this.form.env.appName === 'campanaragricola'){
                    for (const key in resp_fincas) {
                        if (Object.prototype.hasOwnProperty.call(resp_fincas, key)) {
                            const element = resp_fincas[key];
                            if (element?.id_usuario === StorageManager.getUser().id){
                                this.model.id_finca = element.id;
                            }
                        }
                    }
                }
                
                if (resp_fincas.length > 0 ) {
                    if (resp_fincas.length === 1) {
                        this.model.id_finca = resp_fincas[0]?.id ?? '';
                    } 
                }
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }
        const builds = [
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', true),
            build(this.fincasApi.sectoresGET, this.form.lists.sectores, 'nombre', true),
            build(
                this.fincasApi.parcelasGET,
                this.form.lists.parcelas,
                this.form.env.appName === 'avafitogest' ? this.parcelaLabel : 'nombre',
                true,
                true
            ),
            build(
                this.form.env.activateSIEX && !this.form.env.hasPlantas ? 
                    this.siexApi.variedadesClienteGET : 
                    this.formApi.variedadesGET, 
                this.form.lists.variedades, 
                'variedad', 
                true
            ),
            build(this.ventasApi.compradoresGET, this.form.lists.compradores, 'razon_social', true),
            build(this.clientesApi.clientesGET, this.form.lists.clientes, 'nombre'),            
        ];
        if (this.form.env.appName === 'pyf'){
            builds.push(build(this.ventasApi.compradoresGET, this.form.lists.clientes_comercios, 'razon_social', true));
        }
        if (this.form.env.showClientesCooperativa) {
            builds.push(build(this.clientesApi.cooperativasGET, this.form.lists.cooperativas, 'cooperativa'));
        }

        pool(builds, () => {
            setTimeout(() => {
                this.form.lists.variedades.values = (this.form.lists.variedades.values || []).filter(
                    (item, index, self) =>
                        index === self.findIndex(
                            other => 
                                (other.value?.id === item.value?.id) || 
                                (other.value?.variedad === item.value?.variedad)
                        )
                );
                this.form.lists.variedades.filtered = this.form.lists.variedades.values;
                if (this.form.env.appName === 'campanaragricola') {

                    this.form.lists.fincas.filtered = (this.form.lists.fincas.filtered || [])
                        .filter((it) => it && it.value)
                        .map((it) => it.value)
                        .filter((it) =>
                            [it?.id, it?.nombre].includes(StorageManager.getUser().id_finca?.toString())
                        )
                        .map((it) => ({
                            label: it?.nombre ?? '',
                            value: it,
                        }))
                        .sort(Filtering.sort('label', 1));

                    this.form.lists.fincas.filtered.unshift({
                        label: '...',
                        value: null,
                    });
                }
                if (this.form.env.appName === 'avafitogest') {
                    this.form.lists.parcelas.values = (this.form.lists.parcelas.values || []).map(it => ({
                        ...it,
                        label: this.parcelaLabel(it.value as ParcelasModel)
                    }));
                    this.form.lists.parcelas.filtered = this.form.lists.parcelas.values;
                }
                this.finalizeExternalDropdowns();
                this.dropdownLoadTrigger.next();
            }, 3000);
        });
    }

    private parcelaLabel = (p: ParcelasModel) => {
        const nombre = (p.nombre ?? '').toString().trim();
        const variedad = (p.variedad ?? 'SIN VARIEDAD').toString().trim();

        let zonaRiegoAbrev = '';
        if ((p.cultivo ?? '').toLowerCase() === 'arroz') {
            const zr = (p.zona_riego ?? '').toString().toLowerCase();
            if (zr.includes('alta')) zonaRiegoAbrev = 'ZA';
            else if (zr.includes('baja')) zonaRiegoAbrev = 'ZB';
        }

        const variedadConZona = zonaRiegoAbrev
            ? `${variedad} - ${zonaRiegoAbrev}`
            : variedad;

        const pol = (p.poligono ?? '').toString().trim();
        const num = (p.numero ?? '').toString().trim();
        const rec = (p.recinto ?? '').toString().trim();
        const codigos = [pol, num, rec].filter(Boolean).join('-');

        const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
        const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
        const supFmt = supNum.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const uds = environment.features.textoSuperficie || 'ha';

        const derecha = [codigos || undefined, `${supFmt} ${uds}`]
            .filter(Boolean)
            .join(' · ');

        return `${nombre} - ${variedadConZona} — ${derecha}`;
    };
}
